import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const Main = styled.main`
    width: 100%;
    max-width: 1200px;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;
    justify-content: center;
    align-self: center;
`;

export const ImageGalleryWrapper = styled.div`
    width: 100%;
`;

export const AboutSection = styled.section`
    text-align: center;
    padding: 1rem;
`;

export const AboutTitle = styled.h2`
    color: ${colourScheme.success};
`;

export const AboutText = styled.p`
    color: ${colourScheme.fullWhite};
`;

export const GalleryWrapper = styled.div`
    background-color: ${colourScheme.primary};
    padding: 1rem;
    border-radius: 8px; /* Adds rounded corners */
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;

    ${device.md} {
        padding: 2rem;
    }
`;

export const ErrorMessage = styled.div`
    color: ${colourScheme.error};
    margin: 1rem 0;
`;

export const LoadingIndicator = styled.div`
    margin: 2rem 0;
    text-align: center;
    font-size: 1.5rem;
    color: ${colourScheme.primaryDark};
`;

export const SubscriberInfo = styled.p`
    background-color: ${colourScheme.primaryDark};
    color: ${colourScheme.fullWhite};
    font-size: 1rem;
    margin-top: 1rem;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    text-align: center;

    ${device.md} {
        font-size: 1.125rem;
    }
`;

export const SubscriberPerk = styled.span`
    color: ${colourScheme.secondary};
    font-weight: bold;
`;
